<template>
  <div class="meetings-content">
    <div class="sub-header mb-4">
      <b-container fluid>
        <appMeetingsNav
          v-if="$route.name == 'meetings'"
          title="Convocations"
          :breadcrumbs="breadcrumbsNavigationLogic"
          :meeting="meeting"
        />

        <appMeetingsNav
          v-else-if="$route.name == 'create-meeting'"
          title="Créer une convocation"
          :breadcrumbs="breadcrumbsNavigationLogic"
          :meeting="meeting"
        />

        <appMeetingsNav
          v-else-if="$route.name == 'edit-meeting'"
          title="Modifier la convocation"
          :breadcrumbs="breadcrumbsNavigationLogic"
          :meeting="meeting"
        />

        <appMeetingsNav
          v-if="$route.name == 'meeting-correspondence'"
          title="Correspondance"
          :breadcrumbs="breadcrumbsNavigationLogic"
          :meeting="meeting"
        />

        <appMeetingsNav
          v-if="$route.name == 'meeting-agenda'"
          title="Ordre du jour"
          :breadcrumbs="breadcrumbsNavigationLogic"
          :meeting="meeting"
        />

        <appMeetingsNav
          v-else-if="$route.name == 'meeting-presence'"
          title="Présence"
          :breadcrumbs="breadcrumbsNavigationLogic"
          :meeting="meeting"
        />

        <appMeetingsNav
          v-else-if="$route.name == 'meeting-start'"
          title="Les votes"
          :video="video"
          :breadcrumbs="breadcrumbsNavigationLogic"
          :meeting="meeting"
          @setVideo="setVideo"
        />

        <appMeetingsNav
          v-else-if="$route.name == 'meeting-documents'"
          title="Les documents"
          :breadcrumbs="breadcrumbsNavigationLogic"
          :meeting="meeting"
        />
      </b-container>
    </div>

    <b-container fluid>
      <div v-if="$route.name == 'meetings'">
        <b-container>
          <b-row>
            <b-col>
              <b-button class="button btn-blue my-4 fw-600" :to="{ name: 'create-meeting' }">
                <font-awesome-icon class="agv-button-icon" icon="plus" />
                <span>{{ $t("meetings.meeting_create") }}</span>
              </b-button>
            </b-col>
            <b-col class="d-flex align-items-center justify-content-end">
              <b-form-checkbox v-model="displayArchivedMeetings" name="check-button" switch>
                Afficher les réunions archivées
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-container>

        <appMeetingsTable :display-archived-meetings="displayArchivedMeetings" />
      </div>

      <router-view :video="video" />
    </b-container>
  </div>
</template>

<script>
import appMeetingsNav from "@/components/snippets/MeetingsNav";

import MeetingMW from "@/middlewares/Meeting";
import MeetingORM from "@/store/orm-axios/models/Meeting";
import BuildingORM from "@/store/orm-axios/models/Building";

import { mapActions } from "vuex";

import mercureMixin from "@/mixins/mercure-live-changes/meetings";

export default {
  components: {
    appMeetingsTable: () => import("@/components/meetings/MeetingsTable"),
    appMeetingsNav,
  },
  mixins: [mercureMixin],
  data() {
    return {
      video: false,
      displayArchivedMeetings: false,
    };
  },
  computed: {
    meetingsNotifNotSent() {
      return MeetingORM.query().where("status", this.meetingStatuses.notifNotSent).get();
    },
    meetingsInProgress() {
      return MeetingORM.query().where("status", this.meetingStatuses.started).get();
    },
    meeting() {
      return MeetingORM.query().where("id", this.$route.params.id).with("building").first();
    },

    breadcrumbsNavigationLogic() {
      if (this.$route.name == "meetings") {
        return [
          {
            text: "Accueil",
            to: {
              name: "home",
            },
          },
          {
            text: "Liste des convocations",
            active: true,
          },
        ];
      } else {
        return [
          {
            text: "Accueil",
            to: {
              name: "home",
            },
          },
          {
            text: "Convocations",
            to: {
              name: "meetings",
            },
          },
          {
            text: this.buildingName,
            active: true,
          },
        ];
      }
    },
    buildingName() {
      if (!this.isInMeetingUpsert) {
        return this.meetingDetails.BuildingData ? this.meetingDetails.BuildingData.name : "";
      } else if (this.$route.name == "create-meeting") {
        return "Ajouter une nouvelle convocation";
      } else if (this.$route.name == "edit-meeting") {
        if (this.meeting) {
          const building = BuildingORM.find(this.meeting.building_id);
          return building ? building.name : "";
        }
      }

      return "";
    },
  },
  methods: {
    async setVideo($ev) {
      console.log("setVideo $ev", $ev);
      this.video = $ev;
    },
  },
};
</script>
